
import React from "react";
import useAuth from "./useAuth";

interface PermissionGuardProps {
    allowedRoles: string[];
    children: React.ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
    allowedRoles,
    children,
}) => {

    const { isLoggedIn, user } = useAuth();
     if(!isLoggedIn)
        return null;


    const hasPermission = user.roles.some(role => allowedRoles.includes(role));

    if (!hasPermission) {
        return null;
    }

    return <>{children}</>;
};

export default PermissionGuard;
